var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 2.6665H5.33329C3.86263 2.6665 2.66663 3.8625 2.66663 5.33317V29.3332L9.77729 23.9998H26.6666C28.1373 23.9998 29.3333 22.8038 29.3333 21.3332V5.33317C29.3333 3.8625 28.1373 2.6665 26.6666 2.6665ZM26.6666 21.3332H8.88929L5.33329 23.9998V5.33317H26.6666V21.3332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.9998C21.4728 15.9998 22.6667 14.8059 22.6667 13.3332C22.6667 11.8604 21.4728 10.6665 20 10.6665C18.5273 10.6665 17.3334 11.8604 17.3334 13.3332C17.3334 14.8059 18.5273 15.9998 20 15.9998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9998C13.4728 15.9998 14.6667 14.8059 14.6667 13.3332C14.6667 11.8604 13.4728 10.6665 12 10.6665C10.5273 10.6665 9.33337 11.8604 9.33337 13.3332C9.33337 14.8059 10.5273 15.9998 12 15.9998Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageHistory);
export default __webpack_public_path__ + "static/media/messageHistory.dd33bedfb5fe1514e356f4c383179c84.svg";
export { ForwardRef as ReactComponent };